import {
  Button,
  ButtonType,
  TextIconColor,
  Typography,
  TypographySize,
  TypographyWeight
} from '~/components/core';
import { MARKETING_WEBSITE_CONTACT_URL } from '~/constants';

interface PaywallTextProps {
  subtitle?: string | null;
  title?: string;
}

const PaywallText: React.FC<PaywallTextProps> = ({ title, subtitle }) => (
  <div
    className="my-1 flex items-start justify-between"
    data-testid="paywall-text-container"
  >
    <div className="flex flex-col gap-1" data-testid="paywall-text-content">
      <Typography
        color={TextIconColor.DESTRUCTIVE}
        size={TypographySize.LARGE}
        weight={TypographyWeight.MEDIUM}
      >
        {title || 'This feature is limited for Free and Pro users.'}
      </Typography>
      {subtitle !== null && (
        <Typography color={TextIconColor.DESTRUCTIVE}>
          {subtitle || 'To inquire about upgrading, please contact sales.'}
        </Typography>
      )}
    </div>
    <Button
      href={MARKETING_WEBSITE_CONTACT_URL}
      label="Contact Sales"
      type={ButtonType.SOLID}
    />
  </div>
);

export default PaywallText;
